{
  "version": 1,
  "asset_id": "3c5bd867-e117-4b71-bf83-a31e74077365",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/3c5bd867-e117-4b71-bf83-a31e74077365/ind-professional-services-1200.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/3c5bd867-e117-4b71-bf83-a31e74077365/ind-professional-services-1200.webp",
  "original_filename": "ind-professional-services-1200.webp",
  "size": 14864,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:10Z"
}
